/* eslint-disable no-case-declarations */
import * as userAction from "../actions/parser.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    locations: null,
    repoDetails: null,
    user: null,
    repoLoader: false,
    openSuggestion: false,
    parserData: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.PARSER_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    /* falls through */
    case userAction.PARSER_SUCCESS:
      const locations = action && action.locations;
      let parserData = locations && locations.length > 0 ? locations[0] : null;

      return Object.assign({}, state, {
        locations: action.locations,
        status: action.status,
        loading: false,
        parserData,
      });
    /* falls through */
    case userAction.PARSER_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    /* falls through */
    case userAction.SET_PARSER_DATA:
      return Object.assign({}, state, {
        parserData: action.parserData,
      });
    /* falls through */
    default:
      return state;
  }
};
export default user;
